



















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import PicUpload from "@/components/picUpload/index.vue";
import questionSettingTemplate from "./questionSettingTemplate.vue";
import { basicSetting } from "@modules/newCommunity/pages/operationTools/pages/questionnaireEdit/validateUtils/newIndex";

import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore/newIndex";
@Component({
  name: "basicsSetting",
  components: {
    PicUpload,
    questionSettingTemplate,
  },
})
export default class BasicsSetting extends Vue {
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  value!: any;
  @Prop({
    type: Boolean,
    default: false,
  })
  disabled?: any;
  @Watch("value", { deep: true, immediate: true })
  watchPropData() {
    if (JSON.stringify(this.value) != JSON.stringify(this.postForm)) {
      this.postForm = JSON.parse(JSON.stringify(this.value));
      this.clearValidate();
      this.$nextTick(() => {
        this.validate();
      });
    }
  }

  @Watch("postForm", { deep: true })
  watchPostForm() {
    const backup = JSON.parse(JSON.stringify(this.postForm));
    this.$emit("input", backup);
    this.$emit("change", backup);
  }
  private postForm = {
    title: "", // 标题
    introduce: "", // 介绍
    remark: "", //备注
    hideIntro: "0",
    showTip: "0",
    popupText: "",
    leaveBtnText: "",
    cancelBtnText: "",
    coverUrl: "", // 封面
    showTipText: "确定要放弃填写吗？",
  };
  emitChange() {
    const backup = JSON.parse(JSON.stringify(this.postForm));
    this.$emit("input", backup);
    this.$emit("change", backup);
  }
  private rules = {
    title: [{ required: true, type: "string", validator: basicSetting.title, trigger: "blur" }],
    introduce: [{ required: true, type: "string", validator: basicSetting.introduce, trigger: "blur" }],
    popupText: [{ required: true, type: "string", validator: basicSetting.popupText, trigger: "blur" }],
    leaveBtnText: [{ required: true, type: "string", validator: basicSetting.leaveBtnText, trigger: "blur" }],
    cancelBtnText: [{ required: true, type: "string", validator: basicSetting.cancelBtnText, trigger: "blur" }],
    remark: [{ required: false, type: "string", validator: basicSetting.remark, trigger: "blur" }],
  };
  getFormInstance() {
    return this.$refs.postForm as any;
  }
  async validate() {
    return await this.getFormInstance().validate((valid: boolean) => {
      console.log("getFormInstance", valid);
      if (valid) {
        // alert("submit!");
        return true;
      } else {
        // console.log("error submit!!");
        return false;
      }
    });
  }

  resetFields() {
    this.getFormInstance().resetFields();
  }

  clearValidate() {
    if (this.getFormInstance()) {
      this.getFormInstance().clearValidate();
    }
  }
}
